import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ImportCounterCard = ({ label, value, Icon, type }) => {
  const theme = useTheme()
  const color = theme.colors[type].onSurface

  return (
    <Styles.Card type={type}>
      <Styles.Label>
        <Icon size={16} color={color} />
        <Text type="allCapsS" color={color}>
          {label}
        </Text>
      </Styles.Label>
      <Text type="titleM" color={color}>
        <FormatNumber>{value}</FormatNumber>
      </Text>
    </Styles.Card>
  )
}

export default ImportCounterCard
